import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { useClickOutside } from '@/hooks/useClickOutside';

import { NavbarParams, TitleDTO } from './types';
import Layout from './Layout';
import SidebarActions from '@/store/modules/sidebar/duck';

const Navbar: React.FC<NavbarParams> = ({
  title,
  isSearchOpen,
  setSearchOpen,
  goBack,
}) => {
  const [isLangMenuOpen, setLangMenuOpen] = useState(false);
  const [isSettingsMenuOpen, setSettingsMenuOpen] = useState(false);
  const languageMenuRef = useRef(null);
  const settingsMenuRef = useRef(null);
  const dispatch = useDispatch();

  useClickOutside(languageMenuRef, () => setLangMenuOpen(false));
  useClickOutside(settingsMenuRef, () => setSettingsMenuOpen(false));

  const parseTitle = ([main, ...breadcrumb]: string[]): TitleDTO => ({
    main,
    breadcrumb: breadcrumb.length ? ` / ${breadcrumb.join(' / ')}` : undefined,
  });

  const handleOpenMenu = (): void => {
    dispatch(SidebarActions.setOpenOnMobile(true));
  };

  return (
    <Layout
      title={parseTitle(title)}
      isSearchOpen={isSearchOpen}
      setSearchOpen={setSearchOpen}
      setLangMenuOpen={setLangMenuOpen}
      isLangMenuOpen={isLangMenuOpen}
      setSettingsMenuOpen={setSettingsMenuOpen}
      isSettingsMenuOpen={isSettingsMenuOpen}
      languageMenuRef={languageMenuRef}
      settingsMenuRef={settingsMenuRef}
      goBack={goBack}
      openMenu={handleOpenMenu}
    />
  );
};

export default Navbar;
